import React from "react";
import "../../../styles/contactos.css";
import site from "../../../imgs/Icons/site.svg";
import tel from "../../../imgs/Icons/tel.svg";
import fax from "../../../imgs/Icons/fax.svg";
import email from "../../../imgs/Icons/email.svg";
import morada from "../../../imgs/Icons/morada.svg";
import time from "../../../imgs/Icons/time_black.svg";
import { withNamespaces } from 'react-i18next';

const BombeirosAveiro = ({t}) => {
  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <>
      <div
        className="accordion accordions_margin"
        id="accordionExample_bombeirosA"
      >
        {/* 1 - BOMBEIROS VELHOS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="bVelhos">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cBVelhos"
              aria-expanded="true"
              aria-controls="cBVelhos"
            >
              {t('moduleContactosEmergencia:S3.A.A1.T')}
            </button>
          </h2>
          <div
            id="cBVelhos"
            className="accordion-collapse collapse"
            aria-labelledby="bVelhos"
            data-bs-parent="#accordionExample_bombeirosA"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S3.A.A1.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S3.A.A1.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>{t('moduleContactosEmergencia:S3.A.A1.ST1.P2')}
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S3.A.A1.ST1.P3')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S3.A.A1.ST1.P3'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEmergencia:S3.A.A1.ST1.P4')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S3.A.A1.ST1.P4'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a
                    className="link"
                    href={"mailto:" + t('moduleContactosEmergencia:S3.A.A1.ST1.P5')}>
                    {t('moduleContactosEmergencia:S3.A.A1.ST1.P5')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEmergencia:S3.A.A1.ST1.P6')}
                  >
                    {t('moduleContactosEmergencia:S3.A.A1.ST1.P6')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S3.A.A1.ST1.P7')}
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S3.A.A1.ST1.P8')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - BOMBEIROS NOVOS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="bNovos">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cBNovos"
              aria-expanded="true"
              aria-controls="cBNovos"
            >
              {t('moduleContactosEmergencia:S3.A.A2.T')}
            </button>
          </h2>
          <div
            id="cBNovos"
            className="accordion-collapse collapse"
            aria-labelledby="bNovos"
            data-bs-parent="#accordionExample_bombeirosA"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S3.A.A2.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S3.A.A2.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>{t('moduleContactosEmergencia:S3.A.A2.ST1.P2')}
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S3.A.A2.ST1.P3')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S3.A.A2.ST1.P3'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEmergencia:S3.A.A2.ST1.P4')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S3.A.A2.ST1.P4'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a
                    className="link"
                    href={"mailto:" + t('moduleContactosEmergencia:S3.A.A2.ST1.P5')}>
                    {t('moduleContactosEmergencia:S3.A.A2.ST1.P5')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEmergencia:S3.A.A2.ST1.P6')}
                  >
                    {t('moduleContactosEmergencia:S3.A.A2.ST1.P6')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S3.A.A2.ST1.P7')}
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S3.A.A2.ST1.P8')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (BombeirosAveiro);
